// @flow
import React, {
    createContext,
    useState,
    useContext,
    useCallback,
    useMemo,
} from 'react';

type Props = {
    children: React$Element<any>,
};

const BannerContext = createContext();

const BannerProvider = ({ children }: Props): React$Element<any> => {
    const [bannerHeight, setBannerHeight] = useState(0);

    const updateBannerHeight = useCallback((height) => {
        setBannerHeight(height);
    }, []);

    const value = useMemo(
        () => ({
            bannerHeight,
            updateBannerHeight,
        }),
        [bannerHeight, updateBannerHeight]
    );

    return (
        <BannerContext.Provider value={value}>
            {children}
        </BannerContext.Provider>
    );
};

const useBannerContext = (): any => {
    const context = useContext(BannerContext);
    return context;
};

export { useBannerContext, BannerProvider };
